import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/icon'
import SvgIcon from '@/assets/icon/index.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'


const app = createApp(App)
app.use(router)
app.use(ElementPlus)
app.component('svg-icon', SvgIcon)
app.mount('#app')
